function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.74568 0.822327L1.90735e-06 5.56801L12.932 18.5L0 31.432L4.74568 36.1777L22.4234 18.5L4.74568 0.822327Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 37,
    viewBox: "0 0 23 37",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAyMyAzNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC43NDU2OCAwLjgyMjMyN0wxLjkwNzM1ZS0wNiA1LjU2ODAxTDEyLjkzMiAxOC41TDAgMzEuNDMyTDQuNzQ1NjggMzYuMTc3N0wyMi40MjM0IDE4LjVMNC43NDU2OCAwLjgyMjMyN1oiIGZpbGw9IndoaXRlIi8+DQo8L3N2Zz4NCg==";
export { SvgComponent as ReactComponent };